/* eslint-disable jsx-a11y/anchor-is-valid */
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios, { AxiosError } from 'axios';
import clsx from 'clsx';
import { KTSVG } from 'src/_metronic/helpers';
import { InputOTP, InputOTPGroup, InputOTPSlot } from 'src/components/ui/input-otp';
import { withPimURL } from 'src/helpers/service';
import { PLATFORM } from 'src/services/axios/ExpireAxios';
import { announcementUnRead } from 'src/services/redux/slices/announcement/announcement-slice';
import { _login } from 'src/services/redux/slices/auth/auth-slice';
import { LOCK_SMS_URL, VALIDATE_SMS_URL, LOCK_VALIDATE_SMS_URL } from '../redux/AuthCRUD';

export interface IOtpScreenData {
  phoneNumber?: string;
  userName: string;
}

interface IProps {
  data: IOtpScreenData;
  onBack: () => void;
}

const MAX_LENGTH = 4;
const MAX_WIDTH = '20rem';

export function LockOTP(props: IProps) {
  const {
    data: { phoneNumber, userName },
    onBack,
  } = props;
  const [key, setKey] = useState(0);
  const [counter, setCounter] = useState(0);
  const [leftTime, setLeftTime] = useState(counter);
  const [sendCode, setSendCode] = useState<boolean>(false);
  const [smsCode, setSmsCode] = useState<string>('');
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    data: mutationData,
    mutate: validationCode,
    isLoading: mutationIsLoading,
    isSuccess: mutationIsSuccess,
  } = useMutation({
    mutationKey: ['resend-lock-code', phoneNumber],
    mutationFn: async () => {
      await new Promise((res) => {
        setTimeout(res, 2000);
      });
      const { headers, ip = '' } = await axios.get(withPimURL('/vendor/my-ip')).then((res) => res.data);
      const clientIp = headers?.['client-ip']?.[0] || ip || '';

      return axios.post(LOCK_SMS_URL || '', { userName, platform: PLATFORM, clientIp: ip });
    },
    onSuccess: () => {
      setCounter(180);
      setLeftTime(180);
      setSendCode(true);
      setKey((prev) => prev + 1);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        switch (error?.response?.data?.message) {
          case 'INVALID_PASSWORD':
            toast.error('Email veya şifrenizi kontrol edin!');
            break;
          case 'SMS_CODE_IS_NOT_EXPIRED':
            toast.error('3 dakika içinde 1 kez doğrulama kodu talep edebilirsiniz.');
            break;
          case 'ACCOUNT_LOCKED_TOMANY_RETRY':
            toast.error('Bu hesapta birden fazla deneme yapıldığı için kilitlendi.');
            break;
          case 'VENDOR_ACCESS_DENIED_CHECK_PERMISSION':
            toast.error('Satıcı ekranına erişim izniniz bulunmamaktadır.');
            break;
          case 'VENDOR_IS_NOT_ACTIVE':
            toast.error('Satıcı aktif değil');
            break;
          case 'SMS_TOKEN_NOT_ACTIVE':
            toast.error('Onay kodunun süresi doldu. Lütfen tekrar onay kodu isteyiniz.');
            break;
          case 'SMS_VALIDATION_BLOCKED_A_DAY':
            toast.error('24 saat içerisinde yalnızca 5 kez doğrulama kodu talep edebilirsiniz.');
            break;
          case 'WRONG_SMS_CODE':
            toast.error('Girdiğiniz kod eksik veya hatalı. Kontrol edip tekrar deneyin.');
            break;
          case 'SMS_TOKEN_NOT_CONFIRMED':
            toast.error('Onay kodu geçersiz');
            break;
          case 'VENDOR_PHONE_NOT_FOUND':
            toast.error('Satıcının telefon numarası bulunamadı.');
            break;
          default:
            toast.error('Bir sorun oluştu.');
            break;
        }
      } else {
        toast.error('Bir sorun oluştu.');
      }
    },
    retry: false,
    cacheTime: 0,
  });

  const {
    mutate: handleOtpMutation,
    isLoading,
    isSuccess,
  } = useMutation({
    mutationKey: ['auth-lock-otp-validation', mutationData?.data?.token || ''],
    mutationFn: async (data: { smsCode: string; token?: string }) => {
      const _token = mutationData?.data?.token;
      const { headers, ip = '' } = await axios.get(withPimURL('/vendor/my-ip')).then((res) => res.data);
      const clientIp = headers?.['client-ip']?.[0] || ip || '';

      return axios.post(LOCK_VALIDATE_SMS_URL || '', { token: _token, smsCode: data.smsCode, clientIp: ip });
    },
    onSuccess: ({ data }) => {
      onBack();
      toast.success('Yeni şifreniz sms olarak iletilmiştir.');
    },
    onSettled: () => {
      setSmsCode('');
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        switch (error?.response?.data || error?.response?.data?.message) {
          case 'INVALID_PASSWORD':
            toast.error('Email veya şifrenizi kontrol edin!');
            break;
          case 'SMS_CODE_IS_NOT_EXPIRED':
            toast.error('3 dakika içinde 1 kez doğrulama kodu talep edebilirsiniz.');
            break;
          case 'ACCOUNT_LOCKED_TOMANY_RETRY':
            toast.error('Bu hesapta birden fazla deneme yapıldığı için kilitlendi.');
            break;
          case 'VENDOR_ACCESS_DENIED_CHECK_PERMISSION':
            toast.error('Satıcı ekranına erişim izniniz bulunmamaktadır.');
            break;
          case 'VENDOR_IS_NOT_ACTIVE':
            toast.error('Satıcı aktif değil');
            break;
          case 'SMS_TOKEN_NOT_ACTIVE':
            toast.error('Onay kodunun süresi doldu. Lütfen tekrar onay kodu isteyiniz.');
            break;
          case 'SMS_VALIDATION_BLOCKED_A_DAY':
            toast.error('24 saat içerisinde yalnızca 5 kez doğrulama kodu talep edebilirsiniz.');
            break;
          case 'WRONG_SMS_CODE':
            toast.error('Girdiğiniz kod eksik veya hatalı. Kontrol edip tekrar deneyin.');
            break;
          case 'SMS_TOKEN_NOT_CONFIRMED':
            toast.error('Onay kodu geçersiz');
            break;
          case 'VENDOR_PHONE_NOT_FOUND':
            toast.error('Satıcının telefon numarası bulunamadı.');
            break;
          default:
            toast.error('Bir sorun oluştu.');
            break;
        }
      } else {
        toast.error('Bir sorun oluştu.');
      }
    },
    retry: false,
    cacheTime: 0,
  });

  const noLeftTime = leftTime === 0;
  const disableBackButton = mutationIsLoading || isLoading || isSuccess;
  const disableInputs = mutationIsLoading || noLeftTime || isLoading || isSuccess;
  const disableSubmit = mutationIsLoading || noLeftTime || isLoading || isSuccess;

  const onSubmit = (value: string) => {
    if (!disableSubmit) handleOtpMutation({ smsCode: value });
  };

  const handleChange = (newValue: string) => {
    setSmsCode(newValue);
    if (newValue?.length === MAX_LENGTH) {
      onSubmit(newValue);
    }
  };

  return (
    <>
      <form
        className="d-flex flex-column form w-100 rounded"
        onSubmit={(e) => {
          e.preventDefault();
        }}
        noValidate
        autoComplete="off"
      >
        <div className="d-flex align-items-center gap-2 mb-6">
          <button
            type="button"
            className="border-0 bg-transparent"
            onClick={(e) => {
              e.preventDefault();

              if (!disableBackButton) onBack();
            }}
            disabled={disableBackButton}
          >
            <KTSVG path="/media/icons/duotone/Navigation/Angle-left.svg" className="svg-icon-2x" />
          </button>
          <h4 className="text-dark mb-0">Doğrulama kodu girin</h4>
        </div>

        <div className="d-flex w-100 justify-content-center align-items-center mt-10">
          {sendCode && (
            <CountdownCircleTimer
              key={key}
              isPlaying
              duration={180}
              initialRemainingTime={counter}
              colors={['#55BD4F', '#F1416C', '#F1416C']}
              colorsTime={[20, 19, 0]}
              size={110}
              strokeWidth={6}
              trailStrokeWidth={6}
              strokeLinecap="round"
              onUpdate={(remainingTime) => {
                setLeftTime(remainingTime);
                if (remainingTime === 0) setCounter(0);
              }}
            >
              {({ remainingTime }) => {
                const hours = Math.floor(remainingTime / 3600);
                const minutes = Math.floor((remainingTime % 3600) / 60) < 10 ? `0${Math.floor((remainingTime % 3600) / 60)}` : Math.floor((remainingTime % 3600) / 60);
                const seconds = remainingTime % 60 < 10 ? `0${remainingTime % 60}` : remainingTime % 60;

                return hours ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
              }}
            </CountdownCircleTimer>
          )}
        </div>

        <div className="d-flex justify-content-center align-items-center text-center mt-10 mb-10">
          <p className="mb-0" style={{ maxWidth: '70%' }}>
            Değerli iş ortağımız, Yanlış şifre ile giriş denemelerinizden dolayı hesabınız kilitlendi. Sistemde kayıtlı <b>+90{phoneNumber}</b> numaralı telefon numarasına
            doğrulama kodu {!sendCode ? 'gönderilecek' : 'gönderildi'}. Kodunuzla üyeliğinizi tekrar aktif edebilirsiniz.
          </p>
        </div>
        {sendCode && (
          <div className={clsx('d-flex justify-content-center align-items-center', { 'mb-4': noLeftTime, 'mb-6': !noLeftTime })}>
            <div style={{ maxWidth: MAX_WIDTH }}>
              <div className="d-flex flex-column justify-content-center align-items-center position-relative">
                <InputOTP
                  onChange={handleChange}
                  maxLength={4}
                  containerClassName="w-100 justify-content-center"
                  name="otp"
                  autoComplete="off"
                  hasError={noLeftTime}
                  disabled={disableInputs}
                  value={smsCode}
                >
                  <InputOTPGroup>
                    <InputOTPSlot index={0} />
                    <InputOTPSlot index={1} />
                    <InputOTPSlot index={2} />
                    <InputOTPSlot index={3} />
                  </InputOTPGroup>
                </InputOTP>
              </div>

              {noLeftTime ? (
                <div className="d-flex align-items-start gap-2 mt-4">
                  <div className="bg-transparent z-3" style={{ cursor: 'not-allowed' }}>
                    <KTSVG path="/media/icons/duotone/General/Info.svg" className="svg-icon-2 text-danger svg-icon-gray-500 " />
                  </div>
                  <p className="mb-0 text-danger" style={{ fontSize: 12 }}>
                    Onay kodunun süresi doldu. Lütfen tekrar onay kodu isteyiniz.
                  </p>
                </div>
              ) : null}
            </div>
          </div>
        )}
        <div className="d-flex justify-content-center align-items-center">
          {!sendCode && (
            <button className="btn btn-light-primary" type="button" onClick={() => validationCode()} disabled={mutationIsLoading}>
              {!mutationIsLoading && 'Doğrulama Kodu Gönder'}
              {mutationIsLoading && (
                <span className="indicator-progress" style={{ display: 'block' }}>
                  Lütfen bekleyin...
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              )}
            </button>
          )}
        </div>
        {noLeftTime && sendCode ? (
          <div className="d-flex justify-content-center align-items-center mt-10">
            <a
              href="#"
              className={clsx('mb-0 mt-0', { 'opacity-25': mutationIsLoading })}
              onClick={(e) => {
                e.preventDefault();

                if (!mutationIsLoading) validationCode();
              }}
              style={{ cursor: mutationIsLoading ? 'not-allowed' : undefined }}
            >
              Kodu Tekrar Gönder
            </a>
          </div>
        ) : null}

        {/* begin::Action */}
        {/* <div className="text-center mt-4">
          <button type="submit" id="kt_sign_in_submit" className="btn btn-lg btn-primary w-100" disabled={disableSubmitBtn}>
            {!isLoading && <span className="indicator-label">Devam et</span>}
            {isLoading && (
              <span className="indicator-progress" style={{ display: 'block' }}>
                Lütfen bekleyin...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </button>
        </div> */}
        {/* end::Action */}
      </form>
    </>
  );
}
